__turbopack_context__.v({
  "root": "DM2wyq_root",
});
